export const classSubjects = {
  "Prep I": {
    scholastic: [
  { id: "eng_recognize", name: "English Language", spec: "Recognizing Alphabets", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "eng_case_diff", name: "English Language", spec: "Differentiating upper & Lowercase letters", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "eng_listening", name: "English Language", spec: "Listening & grasping skill", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "eng_picture_assoc", name: "English Language", spec: "Associating pictures with alphabets", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "eng_reciting", name: "English Language", spec: "Reciting", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "eng_writing", name: "English Language", spec: "Writing", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "math_recognition", name: "Number Work", spec: "Recognition", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "math_concept", name: "Number Work", spec: "Understanding Math concept", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "math_counting", name: "Number Work", spec: "Identifying & counting the objects", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "math_grouping", name: "Number Work", spec: "Comparing & grouping", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "eng_written_skill", name: "Number Work", spec: "Written skill", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "gen_awareness", name: "General Awareness", spec: "General Awareness", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "story_telling", name: "Story telling", spec: "Story telling", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "drawing_coloring", name: "Drawing & Coloring", spec: "Drawing & Coloring", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "rhymes", name: "Rhymes", spec: "Rhymes", maxMarks: { unitTest: 10, termExam: 10 } }
],
    coScholastic: [],
    traitObservations: [
      { id: "trait_social", name: "Socialism, sharing & caring" },
      { id: "trait_neatness", name: "Neatness & Hygiene" },
      { id: "trait_discipline", name: "Discipline & Manners" },
      { id: "trait_belongings", name: "Care of belongings" },
      { id: "trait_respect", name: "Respecting elders" },
      { id: "trait_confidence", name: "Confidence & self-dependent" },
      { id: "trait_eating", name: "Eating habits" },
      { id: "trait_class_participation", name: "Classroom Participation" },
      { id: "trait_outdoor", name: "Outdoor Participation" },
      { id: "trait_home_assignment", name: "Parent’s Attention towards Home Assignment" },
      { id: "trait_ptm_attendance", name: "Parent’s attendance for Parents Teachers meetings" },
    ],
    template: {
      scholasticFields: ["Subject", "Assessment Specification", "Grade"],
      renderScholastic: (subjects, marks, handleMarksChange, currentStudent, readOnly) => {
        const calculateTotalMax = () => subjects.reduce((sum, subject) => sum + subject.maxMarks, 0);
        const calculateTotalObtained = () =>
          subjects.reduce((sum, subject) => {
            const key = `${currentStudent?.student_id}-${subject.id}-obtained`;
            const gradeValue =
              marks[key] === "A+" ? 9 :
              marks[key] === "A" ? 8 :
              marks[key] === "B+" ? 7 :
              marks[key] === "B" ? 6 :
              marks[key] === "C" ? 4 :
              marks[key] === "AB" ? 0 : 0;
            return sum + (gradeValue * subject.maxMarks) / 10;
          }, 0);
        const calculateGrade = (obtained, max) => {
          if (!obtained || isNaN(obtained) || obtained > max) return "";
          const percentage = (obtained / max) * 100;
          if (percentage >= 88) return "A+";
          if (percentage >= 80) return "A";
          if (percentage >= 70) return "B+";
          if (percentage >= 60) return "B";
          if (percentage >= 40) return "C";
          return "D";
        };

        const totalMax = calculateTotalMax();
        const totalObtained = calculateTotalObtained();
        const percentage = totalMax ? ((totalObtained / totalMax) * 100).toFixed(2) : "0.00";
        const overallGrade = calculateGrade(totalObtained, totalMax);

        return (
          <div className="scholastic-section">
            <h4>Scholastic</h4>
            <table className="results-table">
              <thead>
                <tr>
                  {["Subject", "Assessment Specification", "Grade"].map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {subjects.map((subject, index) => {
                  const key = `${currentStudent?.student_id}-${subject.id}-obtained`;
                  const obtainedMarks = marks[key] || "";
                  const isLastOfSubject =
                    index === subjects.findIndex((s) => s.name !== subject.name) ||
                    index === subjects.length - 1;
                  return (
                    <tr key={subject.id} style={{ borderBottom: isLastOfSubject ? "2px solid black" : "none" }}>
                      <td>{subject.name}</td>
                      <td>{subject.spec}</td>
                      <td>
                        {readOnly ? (
                          <span>{obtainedMarks || "N/A"}</span>
                        ) : (
                          <select
                            value={obtainedMarks}
                            onChange={(e) =>
                              handleMarksChange(currentStudent?.student_id, `${subject.id}-obtained`, e.target.value)
                            }
                            disabled={readOnly}
                          >
                            <option value="">Select Grade</option>
                            {["A+", "A", "B+", "B", "C", "AB"].map((grade) => (
                              <option key={grade} value={grade}>
                                {grade}
                              </option>
                            ))}
                          </select>
                        )}
                      </td>
                    </tr>
                  );
                })}
                
              </tbody>
            </table>
          </div>
        );
      },
      renderCoScholastic: () => null,
      renderTraits: (traitObservations, traitRemarks, handleTraitRemarksChange, currentStudent, readOnly) => (
        <div className="trait-observation-section">
          <h4>Observation</h4>
          <table className="results-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              {traitObservations.map((trait) => {
                const key = `${currentStudent?.student_id}-${trait.id}`;
                const obtainedRemark = traitRemarks[key] || "";
                return (
                  <tr key={trait.id}>
                    <td>{trait.name}</td>
                    <td>
                      {readOnly ? (
                        <span>{obtainedRemark || "N/A"}</span>
                      ) : (
                        <textarea
                          value={obtainedRemark}
                          onChange={(e) =>
                            handleTraitRemarksChange(currentStudent?.student_id, trait.id, e.target.value)
                          }
                          rows={2}
                          style={{ width: "100%" }}
                          placeholder="Write observation"
                        />
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
    },
  },

  "Prep II": {
    scholastic: [
    { id: "eng_recognize", name: "English Language", spec: "Recognizing Alphabets", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "eng_case_diff", name: "English Language", spec: "Differentiating upper & Lowercase letters", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "eng_listening", name: "English Language", spec: "Listening & grasping skill", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "eng_picture_assoc", name: "English Language", spec: "Associating pictures with alphabets", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "eng_reciting", name: "English Language", spec: "Reciting", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "eng_writing", name: "English Language", spec: "Writing", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "math_recognition", name: "Number Work", spec: "Recognition", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "math_concept", name: "Number Work", spec: "Understanding Math concept", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "math_counting", name: "Number Work", spec: "Identifying & counting the objects", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "math_grouping", name: "Number Work", spec: "Comparing & grouping", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "eng_written_skill", name: "Number Work", spec: "Written skill", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "gen_awareness", name: "General Awareness", spec: "General Awareness", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "story_telling", name: "Story telling", spec: "Story telling", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "drawing_coloring", name: "Drawing & Coloring", spec: "Drawing & Coloring", maxMarks: { unitTest: 10, termExam: 10 } },
    { id: "rhymes", name: "Rhymes", spec: "Rhymes", maxMarks: { unitTest: 10, termExam: 10 } }
  ],
    coScholastic: [],
    traitObservations: [
      { id: "trait_social", name: "Socialism, sharing & caring" },
      { id: "trait_neatness", name: "Neatness & Hygiene" },
      { id: "trait_discipline", name: "Discipline & Manners" },
      { id: "trait_belongings", name: "Care of belongings" },
      { id: "trait_respect", name: "Respecting elders" },
      { id: "trait_confidence", name: "Confidence & self-dependent" },
      { id: "trait_eating", name: "Eating habits" },
      { id: "trait_class_participation", name: "Classroom Participation" },
      { id: "trait_outdoor", name: "Outdoor Participation" },
      { id: "trait_home_assignment", name: "Parent’s Attention towards Home Assignment" },
      { id: "trait_ptm_attendance", name: "Parent’s attendance for Parents Teachers meetings" },
    ],
    template: {
      scholasticFields: ["Subject", "Assessment Specification", "Grade"],
      renderScholastic: (subjects, marks, handleMarksChange, currentStudent, readOnly) => (
        <div className="scholastic-section">
          <h4>Scholastic</h4>
          <table className="results-table">
            <thead>
              <tr>
                {["Subject", "Assessment Specification", "Grade"].map((header) => (
                  <th key={header}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {subjects.map((subject, index) => {
                const key = `${currentStudent?.student_id}-${subject.id}-obtained`;
                const obtainedMarks = marks[key] || "";
                const isLastOfSubject =
                  index === subjects.findIndex((s) => s.name !== subject.name) ||
                  index === subjects.length - 1;
                return (
                  <tr key={subject.id} style={{ borderBottom: isLastOfSubject ? "2px solid black" : "none" }}>
                    <td>{subject.name}</td>
                    <td>{subject.spec}</td>
                    <td>
                      {readOnly ? (
                        <span>{obtainedMarks || "N/A"}</span>
                      ) : (
                        <select
                          value={obtainedMarks}
                          onChange={(e) =>
                            handleMarksChange(currentStudent?.student_id, `${subject.id}-obtained`, e.target.value)
                          }
                        >
                          <option value="">Select Grade</option>
                          {["A+", "A", "B+", "B", "C", "AB"].map((grade) => (
                            <option key={grade} value={grade}>
                              {grade}
                            </option>
                          ))}
                        </select>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
      renderCoScholastic: () => null,
      renderTraits: (traitObservations, traitRemarks, handleTraitRemarksChange, currentStudent, readOnly) => (
        <div className="trait-observation-section">
          <h4>Traits / Observation</h4>
          <table className="results-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              {traitObservations.map((trait) => {
                const key = `${currentStudent?.student_id}-${trait.id}`;
                const obtainedRemark = traitRemarks[key] || "";
                return (
                  <tr key={trait.id}>
                    <td>{trait.name}</td>
                    <td>
                      {readOnly ? (
                        <span>{obtainedRemark || "N/A"}</span>
                      ) : (
                        <textarea
                          value={obtainedRemark}
                          onChange={(e) =>
                            handleTraitRemarksChange(currentStudent?.student_id, trait.id, e.target.value)
                          }
                          rows={2}
                          style={{ width: "100%" }}
                          placeholder="Write observation"
                        />
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
    },
  },

  "Prep III": {
    scholastic: [
  { id: "eng_reading", name: "English Language", spec: "Reading", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "eng_pronunciation", name: "English Language", spec: "Pronunciation", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "eng_spelling", name: "English Language", spec: "Spelling", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "eng_reciting", name: "English Language", spec: "Reciting", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "eng_writing", name: "English Language", spec: "Writing", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "math_recognition", name: "Number Work", spec: "Recognition", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "math_concept", name: "Number Work", spec: "Understanding Math concept", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "math_counting", name: "Number Work", spec: "Counting", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "math_comparing", name: "Number Work", spec: "Comparing", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "math_writing", name: "Number Work", spec: "Writing", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "env_knowing", name: "Environmental Education", spec: "Knowing Environment", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "env_dictation", name: "Environmental Education", spec: "Dictation", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "env_writing", name: "Environmental Education", spec: "Writing", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "hindi_identification", name: "Hindi", spec: "Letter Identification", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "hindi_associating", name: "Hindi", spec: "Associating pictures with letters", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "hindi_pronunciation", name: "Hindi", spec: "Pronunciation", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "hindi_writing", name: "Hindi", spec: "Written", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "gen_awareness", name: "General Awareness", spec: "General Awareness", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "story_telling", name: "Story telling", spec: "Story telling", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "drawing_coloring", name: "Drawing & Coloring", spec: "Drawing & Coloring", maxMarks: { unitTest: 10, termExam: 10 } },
  { id: "rhymes", name: "Rhymes", spec: "Rhymes", maxMarks: { unitTest: 10, termExam: 10 } }
],
    coScholastic: [],
    traitObservations: [
      { id: "trait_class_participation", name: "Classroom Participation" },
      { id: "trait_outdoor", name: "Outdoor Participation" },
      { id: "trait_home_assignment", name: "Parent’s Attention towards Home Assignment" },
      { id: "trait_ptm_attendance", name: "Parent’s attendance for Parents Teachers meetings" },
    ],
    template: {
      scholasticFields: ["Subject", "Assessment Specification", "Grade"],
      renderScholastic: (subjects, marks, handleMarksChange, currentStudent, readOnly) => (
        <div className="scholastic-section">
          <h4>Scholastic</h4>
          <table className="results-table">
            <thead>
              <tr>
                {["Subject", "Assessment Specification", "Grade"].map((header) => (
                  <th key={header}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {subjects.map((subject, index) => {
                const key = `${currentStudent?.student_id}-${subject.id}-obtained`;
                const obtainedMarks = marks[key] || "";
                const isLastOfSubject =
                  index === subjects.findIndex((s) => s.name !== subject.name) ||
                  index === subjects.length - 1;
                return (
                  <tr key={subject.id} style={{ borderBottom: isLastOfSubject ? "2px solid black" : "none" }}>
                    <td>{subject.name}</td>
                    <td>{subject.spec}</td>
                    <td>
                      {readOnly ? (
                        <span>{obtainedMarks || "N/A"}</span>
                      ) : (
                        <select
                          value={obtainedMarks}
                          onChange={(e) =>
                            handleMarksChange(currentStudent?.student_id, `${subject.id}-obtained`, e.target.value)
                          }
                        >
                          <option value="">Select Grade</option>
                          {["A+", "A", "B+", "B", "C", "AB"].map((grade) => (
                            <option key={grade} value={grade}>
                              {grade}
                            </option>
                          ))}
                        </select>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
      renderCoScholastic: () => null,
      renderTraits: (traitObservations, traitRemarks, handleTraitRemarksChange, currentStudent, readOnly) => (
        <div className="trait-observation-section">
          <h4>Traits / Observation</h4>
          <table className="results-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              {traitObservations.map((trait) => {
                const key = `${currentStudent?.student_id}-${trait.id}`;
                const obtainedRemark = traitRemarks[key] || "";
                return (
                  <tr key={trait.id}>
                    <td>{trait.name}</td>
                    <td>
                      {readOnly ? (
                        <span>{obtainedRemark || "N/A"}</span>
                      ) : (
                        <textarea
                          value={obtainedRemark}
                          onChange={(e) =>
                            handleTraitRemarksChange(currentStudent?.student_id, trait.id, e.target.value)
                          }
                          rows={2}
                          style={{ width: "100%" }}
                          placeholder="Write observation"
                        />
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
    },
  },

 
  "1": {
    scholastic: [
      { id: "eng_lang_written", name: "English Language", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
      { id: "eng_lang_comprehension", name: "English Language", spec: "Comprehension & Aural", maxMarks: { unitTest: 20, termExam: 20 } },
      { id: "eng_lit_written", name: "English Literature", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
      { id: "eng_lit_reading", name: "English Literature", spec: "Reading, Recitation, Dictation & Communication", maxMarks: { unitTest: 20, termExam: 20 } },
      { id: "kannada_written", name: "Kannada", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
      { id: "kannada_reading", name: "Kannada", spec: "Reading, Recitation, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },
      { id: "hindi_written", name: "Hindi", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
      { id: "hindi_reading", name: "Hindi", spec: "Reading, Recitation, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },
      { id: "math_written", name: "Mathematics", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
      { id: "math_project", name: "Mathematics", spec: "Abacus, Quick Maths & Tables", maxMarks: { unitTest: 20, termExam: 20 } },
      { id: "evs_written", name: "EVS", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
      { id: "evs_project", name: "EVS", spec: "Reading & Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },
      { id: "comp_theory", name: "Computer Studies", spec: "Theory", maxMarks: { unitTest: 25, termExam: 70 } },
      { id: "comp_practical", name: "Computer Studies", spec: "Practical", maxMarks: { unitTest: 5, termExam: 10 } },
      { id: "comp_robotics", name: "Computer Studies", spec: "Robotics & AI", maxMarks: { unitTest: 20, termExam: 20 } },
    ],
    coScholastic: [],
    traitObservations: [
      { id: "trait_punctuality", name: "Punctuality" },
      { id: "trait_enthusiasm", name: "Enthusiasm & Confidence" },
      { id: "trait_class_participation", name: "Participation - Classroom" },
      { id: "trait_activity", name: "Participation - Activity" },
      { id: "trait_eca", name: "ECA" },
      { id: "trait_cca", name: "CCA" },
      { id: "trait_neatness", name: "Neatness" },
      { id: "trait_assignment", name: "Assignment" },
      { id: "trait_art_craft", name: "Art & Craft" },
      { id: "trait_value_education", name: "Value Education" },
    ],
    template: {
      scholasticFields: ["Subject", "Assessment Specification", "Max Marks", "Marks Obtained", "Total Marks", "Grade"],
      renderScholastic: (subjects, marks, handleMarksChange, currentStudent, isAdminFinalized, isUnitTest) => {
        const calculateGrade = (obtained, max) => {
          if (obtained === "") return ""; // Don't assign a grade if marks are not entered

          const numObtained = parseFloat(obtained);
          if (isNaN(numObtained) || numObtained > max) return "";

          if (max === 100 || max === 80 || max === 70) {
            if (numObtained >= max * 0.94) return "A+";
            if (numObtained >= max * 0.84) return "A";
            if (numObtained >= max * 0.69) return "B+";
            if (numObtained >= max * 0.49) return "B";
            if (numObtained >= max * 0.39) return "C";
            return "D";
          }

          if (max === 50 || max === 30) {
            if (numObtained >= max * 0.88) return "A+";
            if (numObtained >= max * 0.78) return "A";
            if (numObtained >= max * 0.68) return "B+";
            if (numObtained >= max * 0.58) return "B";
            if (numObtained >= max * 0.38) return "C";
            return "D";
          }

          if (max === 25 || max === 20 || max === 10 || max === 5) {
            if (numObtained >= max * 0.92) return "A+";
            if (numObtained >= max * 0.80) return "A";
            if (numObtained >= max * 0.60) return "B+";
            if (numObtained >= max * 0.44) return "B";
            if (numObtained >= max * 0.36) return "C";
            return "D";
          }

          // Default fallback
          const percentage = (numObtained / max) * 100;
          if (percentage >= 88) return "A+";
          if (percentage >= 80) return "A";
          if (percentage >= 70) return "B+";
          if (percentage >= 60) return "B";
          if (percentage >= 40) return "C";
          return "D";
        };

        const groupedSubjects = subjects.reduce((acc, subject, index) => {
          const subjectName = subject.name;
          if (!acc[subjectName]) {
            acc[subjectName] = { specs: [], totalMax: 0, totalObtained: 0 };
          }
          const maxMarks = subject.maxMarks; // Use the single maxMarks value set by getFilteredSubjects
          acc[subjectName].specs.push({ ...subject, index, maxMarks });
          acc[subjectName].totalMax += maxMarks;
          const key = `${currentStudent.student_id}-${subject.id}-obtained`;
          const obtainedMarks = marks[key] || "";
          acc[subjectName].totalObtained += obtainedMarks === "" ? 0 : parseFloat(obtainedMarks) || 0;
          return acc;
        }, {});

        return (
          <div className="scholastic-section">
            <h4>Scholastic</h4>
            <table className="results-table">
              <thead>
                <tr>
                  {["Subject", "Assessment Specification", "Max Marks", "Marks Obtained", "Total Marks", "Grade"].map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Object.entries(groupedSubjects).flatMap(([subjectName, { specs, totalMax, totalObtained }]) =>
                  specs.map((subject, specIndex) => {
                    const key = `${currentStudent.student_id}-${subject.id}-obtained`;
                    const obtainedMarks = marks[key] || "";
                    const isLastOfSubject = specIndex === specs.length - 1;
                    const totalMarksDisplay = isLastOfSubject ? totalObtained : "";
                    const grade = isLastOfSubject ? calculateGrade(totalObtained, totalMax) : "";

                    return (
                      <tr key={subject.id} style={{ borderBottom: isLastOfSubject ? "2px solid black" : "none" }}>
                        <td>{specIndex === 0 ? subjectName : ""}</td>
                        <td>{subject.spec}</td>
                        <td>{subject.maxMarks}</td>
                        <td>
                          <input
                            type="text"
                            value={obtainedMarks}
                            onChange={(e) =>
                              handleMarksChange(currentStudent.student_id, `${subject.id}-obtained`, e.target.value)
                            }
                            disabled={isAdminFinalized}
                            className="marks-input"
                          />
                        </td>
                        <td>{totalMarksDisplay}</td>
                        <td>{grade}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        );
      },
      renderCoScholastic: () => null,
      renderTraits: (traitObservations, traitRemarks, handleTraitRemarksChange, currentStudent, isAdminFinalized) => (
        <div className="trait-observation-section">
          <h4>Observation</h4>
          <table className="results-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              {traitObservations.map((trait) => {
                const key = `${currentStudent.student_id}-${trait.id}`;
                return (
                  <tr key={trait.id}>
                    <td>{trait.name}</td>
                    <td>
                      <select
                        value={traitRemarks[key] || ""}
                        onChange={(e) => handleTraitRemarksChange(currentStudent.student_id, trait.id, e.target.value)}
                        disabled={isAdminFinalized}
                      >
                        <option value="">Select Grade</option>
                        {["AB", "B", "B+", "A+", "A"].map((grade) => (
                          <option key={grade} value={grade}>{grade}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
    },
  },


  "2": {
    scholastic: [
      { id: "eng_lang_written", name: "English Language", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
      { id: "eng_lang_comprehension", name: "English Language", spec: "Comprehension & Aural", maxMarks: { unitTest: 20, termExam: 20 } },
      { id: "eng_lit_written", name: "English Literature", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
      { id: "eng_lit_reading", name: "English Literature", spec: "Reading, Recitation, Dictation & Communication", maxMarks: { unitTest: 20, termExam: 20 } },
      { id: "kannada_written", name: "Kannada", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
      { id: "kannada_reading", name: "Kannada", spec: "Reading, Recitation, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },
      { id: "hindi_written", name: "Hindi", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
      { id: "hindi_reading", name: "Hindi", spec: "Reading, Recitation, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },
      { id: "math_written", name: "Mathematics", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
      { id: "math_project", name: "Mathematics", spec: "Project, Quick Maths & Tables", maxMarks: { unitTest: 20, termExam: 20 } },
      { id: "evs_written", name: "EVS", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
      { id: "evs_project", name: "EVS", spec: "Project, Reading & Dictation", maxMarks: { unitTest: 20, termExam: 20 } },
      { id: "comp_theory", name: "Computer Studies", spec: "Theory", maxMarks: { unitTest: 25, termExam: 70 } },
      { id: "comp_practical", name: "Computer Studies", spec: "Practical", maxMarks: { unitTest: 5, termExam: 10 } },
      { id: "comp_robotics", name: "Computer Studies", spec: "Robotics & AI", maxMarks: { unitTest: 20, termExam: 20 } },
    ],

    coScholastic: [],
    traitObservations: [
      { id: "trait_punctuality", name: "Punctuality" },
      { id: "trait_enthusiasm", name: "Enthusiasm & Confidence" },
      { id: "trait_class_participation", name: "Participation - Classroom" },
      { id: "trait_activity", name: "Participation - Activity" },
      { id: "trait_eca", name: "ECA" },
      { id: "trait_cca", name: "CCA" },
      { id: "trait_neatness", name: "Neatness" },
      { id: "trait_assignment", name: "Assignment" },
      { id: "trait_art_craft", name: "Art & Craft" },
      { id: "trait_value_education", name: "Value Education" },
    ],
    template: {
      scholasticFields: ["Subject", "Assessment Specification", "Max Marks", "Marks Obtained", "Total Marks", "Grade"],
      renderScholastic: (subjects, marks, handleMarksChange, currentStudent, isAdminFinalized) => {
       const calculateGrade = (obtained, max) => {
  if (obtained === "") return ""; // Don't assign a grade if marks are not entered

  const numObtained = parseFloat(obtained);
  if (isNaN(numObtained) || numObtained > max) return "";

  if (max === 100) {
    if (numObtained >= 94) return "A+";
    if (numObtained >= 84) return "A";
    if (numObtained >= 69) return "B+";
    if (numObtained >= 49) return "B";
    if (numObtained >= 39) return "C";
    return "D";
  }

  if (max === 50) {
    if (numObtained >= 44) return "A+";
    if (numObtained >= 39) return "A";
    if (numObtained >= 34) return "B+";
    if (numObtained >= 29) return "B";
    if (numObtained >= 19) return "C";
    return "D";
  }

  if (max === 25) {
    if (numObtained >= 23) return "A+";
    if (numObtained >= 20) return "A";
    if (numObtained >= 15) return "B+";
    if (numObtained >= 11) return "B";
    if (numObtained >= 9) return "C";
    return "D";
  }

  // default fallback (if unknown maxMarks)
  const percentage = (numObtained / max) * 100;
  if (percentage >= 88) return "A+";
  if (percentage >= 80) return "A";
  if (percentage >= 70) return "B+";
  if (percentage >= 60) return "B";
  if (percentage >= 40) return "C";
  return "D";
};

        const groupedSubjects = subjects.reduce((acc, subject, index) => {
          const subjectName = subject.name;
          if (!acc[subjectName]) {
            acc[subjectName] = { specs: [], totalMax: 0, totalObtained: 0 };
          }
          acc[subjectName].specs.push({ ...subject, index });
          acc[subjectName].totalMax += subject.maxMarks;
          const key = `${currentStudent.student_id}-${subject.id}-obtained`;
          const obtainedMarks = marks[key] || "";
          acc[subjectName].totalObtained += obtainedMarks === "" ? 0 : parseFloat(obtainedMarks) || 0;
          return acc;
        }, {});

        return (
          <div className="scholastic-section">
            <h4>Scholastic</h4>
            <table className="results-table">
              <thead>
                <tr>
                  {["Subject", "Assessment Specification", "Max Marks", "Marks Obtained", "Total Marks", "Grade"].map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Object.entries(groupedSubjects).flatMap(([subjectName, { specs, totalMax, totalObtained }]) =>
                  specs.map((subject, specIndex) => {
                    const key = `${currentStudent.student_id}-${subject.id}-obtained`;
                    const obtainedMarks = marks[key] || "";
                    const isLastOfSubject = specIndex === specs.length - 1;
                    const totalMarksDisplay = isLastOfSubject ? totalObtained : "";
                    const grade = isLastOfSubject ? calculateGrade(totalObtained, totalMax) : "";

                    return (
                      <tr key={subject.id} style={{ borderBottom: isLastOfSubject ? "2px solid black" : "none" }}>
                        <td>{specIndex === 0 ? subjectName : ""}</td>
                        <td>{subject.spec}</td>
                        <td>{subject.maxMarks}</td>
                        <td>
                          <input
                            type="text"
                            value={obtainedMarks}
                            onChange={(e) =>
                              handleMarksChange(currentStudent.student_id, `${subject.id}-obtained`, e.target.value)
                            }
                            disabled={isAdminFinalized}
                            className="marks-input"
                          />
                        </td>
                        <td>{totalMarksDisplay}</td>
                        <td>{grade}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        );
      },
     renderCoScholastic: () => null,
      renderTraits: (traitObservations, traitRemarks, handleTraitRemarksChange, currentStudent, isAdminFinalized) => (
        <div className="trait-observation-section">
          <h4>Observation</h4>
          <table className="results-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              {traitObservations.map((trait) => {
                const key = `${currentStudent.student_id}-${trait.id}`;
                return (
                  <tr key={trait.id}>
                    <td>{trait.name}</td>
                    <td>
                      <select
                        value={traitRemarks[key] || ""}
                        onChange={(e) => handleTraitRemarksChange(currentStudent.student_id, trait.id, e.target.value)}
                        disabled={isAdminFinalized}
                      >
                        <option value="">Select Grade</option>
                        {["AB", "B", "B+", "A+", "A"].map((grade) => (
                          <option key={grade} value={grade}>{grade}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
    },
  },

  "3": {
    scholastic: [
    { id: "eng_lang_written", name: "English Language", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "eng_lang_comprehension", name: "English Language", spec: "Comprehension & Aural", maxMarks: { unitTest: 20, termExam: 20 } },
    { id: "eng_lit_written", name: "English Literature", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "eng_lit_reading", name: "English Literature", spec: "Reading, Recitation, Dictation & Communication", maxMarks: { unitTest: 20, termExam: 20 } },
    
    { id: "kannada_written", name: "Kannada", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "kannada_reading", name: "Kannada", spec: "Reading, Recitation, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },
    
    { id: "hindi_written", name: "Hindi", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "hindi_reading", name: "Hindi", spec: "Reading, Recitation, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },
    
    { id: "math_written", name: "Mathematics", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "math_project", name: "Mathematics", spec: "Abacus, Quick Maths & Tables", maxMarks: { unitTest: 20, termExam: 20 } },
    
    { id: "science_written", name: "Science", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "science_project", name: "Science", spec: "Reading, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },
    
    { id: "social_written", name: "Social Studies", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "social_project", name: "Social Studies", spec: "Reading, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },
    
    { id: "comp_theory", name: "Computer Studies", spec: "Theory", maxMarks: { unitTest: 25, termExam: 70 } },
    { id: "comp_practical", name: "Computer Studies", spec: "Practical", maxMarks: { unitTest: 5, termExam: 10 } },
    { id: "comp_robotics", name: "Computer Studies", spec: "Robotics & AI", maxMarks: { unitTest: 20, termExam: 20 } },
   ],
    coScholastic: [],
    traitObservations: [
      { id: "trait_punctuality", name: "Punctuality" },
      { id: "trait_enthusiasm", name: "Enthusiasm & Confidence" },
      { id: "trait_class_participation", name: "Participation - Classroom" },
      { id: "trait_activity", name: "Participation - Activity" },
      { id: "trait_eca", name: "ECA" },
      { id: "trait_cca", name: "CCA" },
      { id: "trait_neatness", name: "Neatness" },
      { id: "trait_assignment", name: "Assignment" },
      { id: "trait_art_craft", name: "Art & Craft" },
      { id: "trait_value_education", name: "Value Education" },
    ],
    template: {
      scholasticFields: ["Subject", "Assessment Specification", "Max Marks", "Marks Obtained", "Total Marks", "Grade"],
      renderScholastic: (subjects, marks, handleMarksChange, currentStudent, isAdminFinalized) => {
        const calculateGrade = (obtained, max) => {
  if (obtained === "") return ""; // Don't assign a grade if marks are not entered

  const numObtained = parseFloat(obtained);
  if (isNaN(numObtained) || numObtained > max) return "";

  if (max === 100) {
    if (numObtained >= 94) return "A+";
    if (numObtained >= 84) return "A";
    if (numObtained >= 69) return "B+";
    if (numObtained >= 49) return "B";
    if (numObtained >= 39) return "C";
    return "D";
  }

  if (max === 50) {
    if (numObtained >= 44) return "A+";
    if (numObtained >= 39) return "A";
    if (numObtained >= 34) return "B+";
    if (numObtained >= 29) return "B";
    if (numObtained >= 19) return "C";
    return "D";
  }

  if (max === 25) {
    if (numObtained >= 23) return "A+";
    if (numObtained >= 20) return "A";
    if (numObtained >= 15) return "B+";
    if (numObtained >= 11) return "B";
    if (numObtained >= 9) return "C";
    return "D";
  }

  // default fallback (if unknown maxMarks)
  const percentage = (numObtained / max) * 100;
  if (percentage >= 88) return "A+";
  if (percentage >= 80) return "A";
  if (percentage >= 70) return "B+";
  if (percentage >= 60) return "B";
  if (percentage >= 40) return "C";
  return "D";
};

        const groupedSubjects = subjects.reduce((acc, subject, index) => {
          const subjectName = subject.name;
          if (!acc[subjectName]) {
            acc[subjectName] = { specs: [], totalMax: 0, totalObtained: 0 };
          }
          acc[subjectName].specs.push({ ...subject, index });
          acc[subjectName].totalMax += subject.maxMarks;
          const key = `${currentStudent.student_id}-${subject.id}-obtained`;
          const obtainedMarks = marks[key] || "";
          acc[subjectName].totalObtained += obtainedMarks === "" ? 0 : parseFloat(obtainedMarks) || 0;
          return acc;
        }, {});

        return (
          <div className="scholastic-section">
            <h4>Scholastic</h4>
            <table className="results-table">
              <thead>
                <tr>
                  {["Subject", "Assessment Specification", "Max Marks", "Marks Obtained", "Total Marks", "Grade"].map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Object.entries(groupedSubjects).flatMap(([subjectName, { specs, totalMax, totalObtained }]) =>
                  specs.map((subject, specIndex) => {
                    const key = `${currentStudent.student_id}-${subject.id}-obtained`;
                    const obtainedMarks = marks[key] || "";
                    const isLastOfSubject = specIndex === specs.length - 1;
                    const totalMarksDisplay = isLastOfSubject ? totalObtained : "";
                    const grade = isLastOfSubject ? calculateGrade(totalObtained, totalMax) : "";

                    return (
                      <tr key={subject.id} style={{ borderBottom: isLastOfSubject ? "2px solid black" : "none" }}>
                        <td>{specIndex === 0 ? subjectName : ""}</td>
                        <td>{subject.spec}</td>
                        <td>{subject.maxMarks}</td>
                        <td>
                          <input
                            type="text"
                            value={obtainedMarks}
                            onChange={(e) =>
                              handleMarksChange(currentStudent.student_id, `${subject.id}-obtained`, e.target.value)
                            }
                            disabled={isAdminFinalized}
                            className="marks-input"
                          />
                        </td>
                        <td>{totalMarksDisplay}</td>
                        <td>{grade}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        );
      },
     renderCoScholastic: () => null,
      renderTraits: (traitObservations, traitRemarks, handleTraitRemarksChange, currentStudent, isAdminFinalized) => (
        <div className="trait-observation-section">
          <h4>Observation</h4>
          <table className="results-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              {traitObservations.map((trait) => {
                const key = `${currentStudent.student_id}-${trait.id}`;
                return (
                  <tr key={trait.id}>
                    <td>{trait.name}</td>
                    <td>
                      <select
                        value={traitRemarks[key] || ""}
                        onChange={(e) => handleTraitRemarksChange(currentStudent.student_id, trait.id, e.target.value)}
                        disabled={isAdminFinalized}
                        className="grade-select"
                      >
                        <option value="">Select Grade</option>
                        {["A+", "A", "B+", "B", "C", "AB"].map((grade) => (
                          <option key={grade} value={grade}>{grade}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
    },
  },

    "4": {
scholastic: [
    { id: "eng_lang_written", name: "English Language", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "eng_lang_comprehension", name: "English Language", spec: "Comprehension & Aural", maxMarks: { unitTest: 20, termExam: 20 } },
    { id: "eng_lit_written", name: "English Literature", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "eng_lit_reading", name: "English Literature", spec: "Reading, Recitation, Dictation & Communication", maxMarks: { unitTest: 20, termExam: 20 } },

    { id: "ii_lang_written", name: "II Language Kannada / Hindi", groupId: "ii_language", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "ii_lang_reading", name: "II Language Kannada / Hindi", groupId: "ii_language", spec: "Reading, Recitation, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },

    { id: "iii_lang_written", name: "III Language Kannada / Hindi", groupId: "iii_language", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "iii_lang_reading", name: "III Language Kannada / Hindi", groupId: "iii_language", spec: "Reading, Recitation, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },

    { id: "math_written", name: "Mathematics", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "math_project", name: "Mathematics", spec: "Abacus, Quick Maths & Tables", maxMarks: { unitTest: 20, termExam: 20 } },

    { id: "science_written", name: "Science", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "science_project", name: "Science", spec: "Reading, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },

    { id: "social_written", name: "Social Studies", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "social_project", name: "Social Studies", spec: "Reading, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },

    { id: "comp_theory", name: "Computer Studies", spec: "Theory", maxMarks: { unitTest: 25, termExam: 70 } },
    { id: "comp_practical", name: "Computer Studies", spec: "Practical", maxMarks: { unitTest: 5, termExam: 10 } },
    { id: "comp_robotics", name: "Computer Studies", spec: "Robotics & AI", maxMarks: { unitTest: 20, termExam: 20 } }
  ],
  coScholastic: [],
  traitObservations: [
    { id: "trait_punctuality", name: "Punctuality" },
    { id: "trait_enthusiasm", name: "Enthusiasm & Confidence" },
    { id: "trait_class_participation", name: "Participation - Classroom" },
    { id: "trait_activity", name: "Participation - Activity" },
    { id: "trait_eca", name: "ECA" },
    { id: "trait_cca", name: "CCA" },
    { id: "trait_neatness", name: "Neatness" },
    { id: "trait_assignment", name: "Assignment" },
    { id: "trait_art_craft", name: "Art & Craft" },
    { id: "trait_value_education", name: "Value Education" }
  ],
  template: {
    scholasticFields: ["Subject", "Assessment Specification", "Max Marks", "Marks Obtained", "Total Marks", "Grade"],
    renderScholastic: (subjects, marks, handleMarksChange, currentStudent, isAdminFinalized) => {
      const calculateGrade = (obtained, max) => {
        if (obtained === "") return "";
        const numObtained = parseFloat(obtained);
        if (isNaN(numObtained) || numObtained > max) return "";

        if (max === 100) {
          if (numObtained >= 94) return "A+";
          if (numObtained >= 84) return "A";
          if (numObtained >= 69) return "B+";
          if (numObtained >= 49) return "B";
          if (numObtained >= 39) return "C";
          return "D";
        }

        if (max === 50) {
          if (numObtained >= 44) return "A+";
          if (numObtained >= 39) return "A";
          if (numObtained >= 34) return "B+";
          if (numObtained >= 29) return "B";
          if (numObtained >= 19) return "C";
          return "D";
        }

        if (max === 25) {
          if (numObtained >= 23) return "A+";
          if (numObtained >= 20) return "A";
          if (numObtained >= 15) return "B+";
          if (numObtained >= 11) return "B";
          if (numObtained >= 9) return "C";
          return "D";
        }

        const percentage = (numObtained / max) * 100;
        if (percentage >= 88) return "A+";
        if (percentage >= 80) return "A";
        if (percentage >= 70) return "B+";
        if (percentage >= 60) return "B";
        if (percentage >= 40) return "C";
        return "D";
      };

      const groupedSubjects = subjects.reduce((acc, subject, index) => {
        const groupKey = subject.groupId || subject.name;
        const displayName = subject.name;

        if (!acc[groupKey]) {
          acc[groupKey] = { displayName, specs: [], totalMax: 0, totalObtained: 0 };
        }

        acc[groupKey].specs.push({ ...subject, index });
        acc[groupKey].totalMax += subject.maxMarks;

        const key = `${currentStudent.student_id}-${subject.id}-obtained`;
        const obtainedMarks = marks[key] || "";
        acc[groupKey].totalObtained += obtainedMarks === "" ? 0 : parseFloat(obtainedMarks) || 0;

        return acc;
      }, {});

      return (
        <div className="scholastic-section">
          <h4>Scholastic</h4>
          <table className="results-table">
            <thead>
              <tr>
                {["Subject", "Assessment Specification", "Max Marks", "Marks Obtained", "Total Marks", "Grade"].map((header) => (
                  <th key={header}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Object.entries(groupedSubjects).flatMap(([groupKey, { displayName, specs, totalMax, totalObtained }]) =>
                specs.map((subject, specIndex) => {
                  const key = `${currentStudent.student_id}-${subject.id}-obtained`;
                  const obtainedMarks = marks[key] || "";
                  const isLast = specIndex === specs.length - 1;
                  const totalMarksDisplay = isLast ? totalObtained : "";
                  const grade = isLast ? calculateGrade(totalObtained, totalMax) : "";

                  return (
                    <tr key={subject.id} style={{ borderBottom: isLast ? "2px solid black" : "none" }}>
                      <td>{specIndex === 0 ? displayName : ""}</td>
                      <td>{subject.spec}</td>
                      <td>{subject.maxMarks}</td>
                      <td>
                        <input
                          type="text"
                          value={obtainedMarks}
                          onChange={(e) =>
                            handleMarksChange(currentStudent.student_id, `${subject.id}-obtained`, e.target.value)
                          }
                          disabled={isAdminFinalized}
                          className="marks-input"
                        />
                      </td>
                      <td>{totalMarksDisplay}</td>
                      <td>{grade}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      );
    },
    renderCoScholastic: () => null,
    renderTraits: (traitObservations, traitRemarks, handleTraitRemarksChange, currentStudent, isAdminFinalized) => (
      <div className="trait-observation-section">
        <h4>Observation</h4>
        <table className="results-table">
          <thead>
            <tr>
              <th>Subject</th>
              <th>Grade</th>
            </tr>
          </thead>
          <tbody>
            {traitObservations.map((trait) => {
              const key = `${currentStudent.student_id}-${trait.id}`;
              return (
                <tr key={trait.id}>
                  <td>{trait.name}</td>
                  <td>
                    <select
                      value={traitRemarks[key] || ""}
                      onChange={(e) => handleTraitRemarksChange(currentStudent.student_id, trait.id, e.target.value)}
                      disabled={isAdminFinalized}
                      className="grade-select"
                    >
                      <option value="">Select Grade</option>
                      {["A+", "A", "B+", "B", "C", "AB"].map((grade) => (
                        <option key={grade} value={grade}>{grade}</option>
                      ))}
                    </select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )
  }
},
"5": {
  scholastic: [
    { id: "eng_lang_written", name: "English Language", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "eng_lang_comprehension", name: "English Language", spec: "Comprehension & Aural", maxMarks: { unitTest: 20, termExam: 20 } },
    { id: "eng_lit_written", name: "English Literature", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "eng_lit_reading", name: "English Literature", spec: "Reading, Recitation, Dictation & Communication", maxMarks: { unitTest: 20, termExam: 20 } },

    { id: "ii_lang_written", name: "II Language Kannada / Hindi", groupId: "ii_language", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "ii_lang_reading", name: "II Language Kannada / Hindi", groupId: "ii_language", spec: "Reading, Recitation, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },

    { id: "iii_lang_written", name: "III Language Kannada / Hindi", groupId: "iii_language", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "iii_lang_reading", name: "III Language Kannada / Hindi", groupId: "iii_language", spec: "Reading, Recitation, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },

    { id: "math_written", name: "Mathematics", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "math_project", name: "Mathematics", spec: "Abacus, Quick Maths & Tables", maxMarks: { unitTest: 20, termExam: 20 } },

    { id: "science_written", name: "Science", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "science_project", name: "Science", spec: "Reading, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },

    { id: "social_written", name: "Social Studies", spec: "Written", maxMarks: { unitTest: 30, termExam: 80 } },
    { id: "social_project", name: "Social Studies", spec: "Reading, Dictation & Skill Sheet", maxMarks: { unitTest: 20, termExam: 20 } },

    { id: "comp_theory", name: "Computer Studies", spec: "Theory", maxMarks: { unitTest: 25, termExam: 70 } },
    { id: "comp_practical", name: "Computer Studies", spec: "Practical", maxMarks: { unitTest: 5, termExam: 10 } },
    { id: "comp_robotics", name: "Computer Studies", spec: "Robotics & AI", maxMarks: { unitTest: 20, termExam: 20 } }
  ],
  coScholastic: [],
  traitObservations: [
    { id: "trait_punctuality", name: "Punctuality" },
    { id: "trait_enthusiasm", name: "Enthusiasm & Confidence" },
    { id: "trait_class_participation", name: "Participation - Classroom" },
    { id: "trait_activity", name: "Participation - Activity" },
    { id: "trait_eca", name: "ECA" },
    { id: "trait_cca", name: "CCA" },
    { id: "trait_neatness", name: "Neatness" },
    { id: "trait_assignment", name: "Assignment" },
    { id: "trait_art_craft", name: "Art & Craft" },
    { id: "trait_value_education", name: "Value Education" }
  ],
  template: {
    scholasticFields: ["Subject", "Assessment Specification", "Max Marks", "Marks Obtained", "Total Marks", "Grade"],
    renderScholastic: (subjects, marks, handleMarksChange, currentStudent, isAdminFinalized) => {
      const calculateGrade = (obtained, max) => {
        if (obtained === "") return "";
        const numObtained = parseFloat(obtained);
        if (isNaN(numObtained) || numObtained > max) return "";
        if (max === 100) {
          if (numObtained >= 94) return "A+";
          if (numObtained >= 84) return "A";
          if (numObtained >= 69) return "B+";
          if (numObtained >= 49) return "B";
          if (numObtained >= 39) return "C";
          return "D";
        }
        if (max === 50) {
          if (numObtained >= 44) return "A+";
          if (numObtained >= 39) return "A";
          if (numObtained >= 34) return "B+";
          if (numObtained >= 29) return "B";
          if (numObtained >= 19) return "C";
          return "D";
        }
        if (max === 25) {
          if (numObtained >= 23) return "A+";
          if (numObtained >= 20) return "A";
          if (numObtained >= 15) return "B+";
          if (numObtained >= 11) return "B";
          if (numObtained >= 9) return "C";
          return "D";
        }
        const percentage = (numObtained / max) * 100;
        if (percentage >= 88) return "A+";
        if (percentage >= 80) return "A";
        if (percentage >= 70) return "B+";
        if (percentage >= 60) return "B";
        if (percentage >= 40) return "C";
        return "D";
      };

      const groupedSubjects = subjects.reduce((acc, subject, index) => {
        const subjectKey = subject.groupId || subject.name;
        const displayName = subject.name;
        if (!acc[subjectKey]) {
          acc[subjectKey] = { displayName, specs: [], totalMax: 0, totalObtained: 0 };
        }
        acc[subjectKey].specs.push({ ...subject, index });
        acc[subjectKey].totalMax += subject.maxMarks;
        const key = `${currentStudent.student_id}-${subject.id}-obtained`;
        const obtainedMarks = marks[key] || "";
        acc[subjectKey].totalObtained += obtainedMarks === "" ? 0 : parseFloat(obtainedMarks) || 0;
        return acc;
      }, {});

      return (
        <div className="scholastic-section">
          <h4>Scholastic</h4>
          <table className="results-table">
            <thead>
              <tr>
                {["Subject", "Assessment Specification", "Max Marks", "Marks Obtained", "Total Marks", "Grade"].map((header) => (
                  <th key={header}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Object.entries(groupedSubjects).flatMap(([subjectKey, { displayName, specs, totalMax, totalObtained }]) =>
                specs.map((subject, specIndex) => {
                  const key = `${currentStudent.student_id}-${subject.id}-obtained`;
                  const obtainedMarks = marks[key] || "";
                  const isLastOfSubject = specIndex === specs.length - 1;
                  const totalMarksDisplay = isLastOfSubject ? totalObtained : "";
                  const grade = isLastOfSubject ? calculateGrade(totalObtained, totalMax) : "";

                  return (
                    <tr key={subject.id} style={{ borderBottom: isLastOfSubject ? "2px solid black" : "none" }}>
                      <td>{specIndex === 0 ? displayName : ""}</td>
                      <td>{subject.spec}</td>
                      <td>{subject.maxMarks}</td>
                      <td>
                        <input
                          type="text"
                          value={obtainedMarks}
                          onChange={(e) =>
                            handleMarksChange(currentStudent.student_id, `${subject.id}-obtained`, e.target.value)
                          }
                          disabled={isAdminFinalized}
                          className="marks-input"
                        />
                      </td>
                      <td>{totalMarksDisplay}</td>
                      <td>{grade}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      );
    },
    renderCoScholastic: () => null,
    renderTraits: (traitObservations, traitRemarks, handleTraitRemarksChange, currentStudent, isAdminFinalized) => (
      <div className="trait-observation-section">
        <h4>Observation</h4>
        <table className="results-table">
          <thead>
            <tr>
              <th>Subject</th>
              <th>Grade</th>
            </tr>
          </thead>
          <tbody>
            {traitObservations.map((trait) => {
              const key = `${currentStudent.student_id}-${trait.id}`;
              return (
                <tr key={trait.id}>
                  <td>{trait.name}</td>
                  <td>
                    <select
                      value={traitRemarks[key] || ""}
                      onChange={(e) => handleTraitRemarksChange(currentStudent.student_id, trait.id, e.target.value)}
                      disabled={isAdminFinalized}
                      className="grade-select"
                    >
                      <option value="">Select Grade</option>
                      {["A+", "A", "B+", "B", "C", "AB"].map((grade) => (
                        <option key={grade} value={grade}>{grade}</option>
                      ))}
                    </select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )
  }
},

  "6": {
    scholastic: [
  { id: "eng_paper1", name: "English Paper I (Language)", spec: "English Paper I (Language)", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "eng_paper2", name: "English Paper II (Literature)", spec: "English Paper II (Literature)", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "ii_language", name: "II Language", spec: "II Language", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "iii_language", name: "III Language", spec: "III Language", maxMarks: { unitTest: 25, termExam: 50 } },
  { id: "hcg_paper1", name: "H.C.G Paper I (History & Civics)", spec: "H.C.G Paper I (History & Civics)", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "hcg_paper2", name: "H.C.G Paper II (Geography)", spec: "H.C.G Paper II (Geography)", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "math", name: "Mathematics", spec: "Mathematics", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "physics", name: "Physics", spec: "Physics", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "chemistry", name: "Chemistry", spec: "Chemistry", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "biology", name: "Biology", spec: "Biology", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "computer_app", name: "Computer Application", spec: "Computer Application", maxMarks: { unitTest: 50, termExam: 100 } },
  ],
    coScholastic: [
      { id: "co_analytical_thinking", name: "Analytical Thinking" },
      { id: "co_value_education", name: "Value Education" },
      { id: "co_robotics", name: "Robotics" },
      { id: "co_communication_skill", name: "Communication Skill" },
      { id: "co_vocational_edu", name: "Vocational Education / SUPW / Art & Craft" },
    ],
    traitObservations: [
      { id: "trait_punctuality", name: "Punctuality" },
      { id: "trait_enthusiasm", name: "Enthusiasm & Confidence" },
      { id: "trait_class_participation", name: "Participation – Classroom" },
      { id: "trait_outdoor", name: "Participation – Outdoor" },
      { id: "trait_eca", name: "ECA" },
      { id: "trait_cca", name: "CCA" },
      { id: "trait_neatness", name: "Neatness" },
      { id: "trait_discipline", name: "Discipline" },
    ],
    template: {
      scholasticFields: ["Subject", "Max Marks", "Marks Obtained", "Grade"],
      renderScholastic: (subjects, marks, handleMarksChange, currentStudent, isAdminFinalized) => {
const calculateGrade = (obtained, max) => {
  if (obtained === "") return ""; // Don't assign a grade if marks are not entered

  const numObtained = parseFloat(obtained);
  if (isNaN(numObtained) || numObtained > max) return "";

  if (max === 100) {
    if (numObtained >= 94) return "A+";
    if (numObtained >= 84) return "A";
    if (numObtained >= 69) return "B+";
    if (numObtained >= 49) return "B";
    if (numObtained >= 39) return "C";
    return "D";
  }

  if (max === 50) {
    if (numObtained >= 44) return "A+";
    if (numObtained >= 39) return "A";
    if (numObtained >= 34) return "B+";
    if (numObtained >= 29) return "B";
    if (numObtained >= 19) return "C";
    return "D";
  }

  if (max === 25) {
    if (numObtained >= 23) return "A+";
    if (numObtained >= 20) return "A";
    if (numObtained >= 15) return "B+";
    if (numObtained >= 11) return "B";
    if (numObtained >= 9) return "C";
    return "D";
  }

  // default fallback (if unknown maxMarks)
  const percentage = (numObtained / max) * 100;
  if (percentage >= 88) return "A+";
  if (percentage >= 80) return "A";
  if (percentage >= 70) return "B+";
  if (percentage >= 60) return "B";
  if (percentage >= 40) return "C";
  return "D";
};



        return (
          <div className="scholastic-section">
            <h4>Scholastic</h4>
            <table className="results-table">
              <thead>
                <tr>
                  {["Subject", "Max Marks", "Marks Obtained", "Grade"].map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {subjects.map((subject) => {
                  const key = `${currentStudent.student_id}-${subject.id}-obtained`;
                  const obtainedMarks = marks[key] || "";
                  const calculatedGrade = calculateGrade(obtainedMarks, subject.maxMarks);

                  return (
                    <tr key={subject.id}>
                      <td>{subject.name}</td>
                      <td>{subject.maxMarks}</td>
                      <td>
                        <input
                          type="text"
                          value={obtainedMarks}
                          onChange={(e) =>
                            handleMarksChange(currentStudent.student_id, `${subject.id}-obtained`, e.target.value)
                          }
                          disabled={isAdminFinalized}
                          className="marks-input"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={calculatedGrade}
                          readOnly
                          style={{ width: "60px" }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      },
      renderCoScholastic: (coSubjects, coMarks, handleCoMarksChange, currentStudent, isAdminFinalized) => (
        <div className="co-scholastic-section">
          <h4>Co-Scholastic</h4>
          <table className="results-table">
            <thead>
              <tr>
                {["Subjects", "Grade"].map((header) => (
                  <th key={header}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {coSubjects.map((coSubject) => {
                const key = `${currentStudent.student_id}-${coSubject.id}-obtained`;
                return (
                  <tr key={coSubject.id}>
                    <td>{coSubject.name}</td>
                    <td>
                      {isAdminFinalized ? (
                        <span>{coMarks[key] || "N/A"}</span>
                      ) : (
                        <select
                          value={coMarks[key] || ""}
                          onChange={(e) => handleCoMarksChange(currentStudent.student_id, `${coSubject.id}-obtained`, e.target.value)}
                          disabled={isAdminFinalized}
                        >
                          <option value="">Select Grade</option>
                          {["AB", "B+", "A", "A+"].map((grade) => (
                            <option key={grade} value={grade}>{grade}</option>
                          ))}
                        </select>
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>          </table>
        </div>
      ),
      renderTraits: (traitObservations, traitRemarks, handleTraitRemarksChange, currentStudent, isAdminFinalized) => (
        <div className="trait-observation-section">
          <h4>Observation</h4>
          <table className="results-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              {traitObservations.map((trait) => {
                const key = `${currentStudent.student_id}-${trait.id}`;
                return (
                  <tr key={trait.id}>
                    <td>{trait.name}</td>
                    <td>
                      <select
                        value={traitRemarks[key] || ""}
                        onChange={(e) => handleTraitRemarksChange(currentStudent.student_id, trait.id, e.target.value)}
                        disabled={isAdminFinalized}
                        className="grade-select"
                      >
                        <option value="">Select Grade</option>
                        {["A+", "A", "B+", "B", "C", "AB"].map((grade) => (
                          <option key={grade} value={grade}>{grade}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
    },
  },

  "7": {
    scholastic: [
  { id: "eng_paper1", name: "English Paper I (Language)", spec: "English Paper I (Language)", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "eng_paper2", name: "English Paper II (Literature)", spec: "English Paper II (Literature)", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "ii_language", name: "II Language", spec: "II Language", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "iii_language", name: "III Language", spec: "III Language", maxMarks: { unitTest: 25, termExam: 50 } },
  { id: "hcg_paper1", name: "H.C.G Paper I (History & Civics)", spec: "H.C.G Paper I (History & Civics)", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "hcg_paper2", name: "H.C.G Paper II (Geography)", spec: "H.C.G Paper II (Geography)", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "math", name: "Mathematics", spec: "Mathematics", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "physics", name: "Physics", spec: "Physics", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "chemistry", name: "Chemistry", spec: "Chemistry", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "biology", name: "Biology", spec: "Biology", maxMarks: { unitTest: 50, termExam: 100 } },
  { id: "computer_app", name: "Computer Application", spec: "Computer Application", maxMarks: { unitTest: 50, termExam: 100 } }
],

    coScholastic: [
      { id: "co_analytical_thinking", name: "Analytical Thinking" },
      { id: "co_value_education", name: "Value Education" },
      { id: "co_robotics", name: "Robotics" },
      { id: "co_communication_skill", name: "Communication Skill" },
      { id: "co_vocational_edu", name: "Vocational Education / SUPW / Art & Craft" },
    ],
    traitObservations: [
      { id: "trait_punctuality", name: "Punctuality" },
      { id: "trait_enthusiasm", name: "Enthusiasm & Confidence" },
      { id: "trait_class_participation", name: "Participation – Classroom" },
      { id: "trait_outdoor", name: "Participation – Outdoor" },
      { id: "trait_eca", name: "ECA" },
      { id: "trait_cca", name: "CCA" },
      { id: "trait_neatness", name: "Neatness" },
      { id: "trait_discipline", name: "Discipline" },
    ],
    template: {
      scholasticFields: ["Subject", "Max Marks", "Marks Obtained", "Grade"],
      renderScholastic: (subjects, marks, handleMarksChange, currentStudent, isAdminFinalized) => {
   const calculateGrade = (obtained, max) => {
  if (obtained === "") return ""; // Don't assign a grade if marks are not entered

  const numObtained = parseFloat(obtained);
  if (isNaN(numObtained) || numObtained > max) return "";

  if (max === 100) {
    if (numObtained >= 94) return "A+";
    if (numObtained >= 84) return "A";
    if (numObtained >= 69) return "B+";
    if (numObtained >= 49) return "B";
    if (numObtained >= 39) return "C";
    return "D";
  }

  if (max === 50) {
    if (numObtained >= 44) return "A+";
    if (numObtained >= 39) return "A";
    if (numObtained >= 34) return "B+";
    if (numObtained >= 29) return "B";
    if (numObtained >= 19) return "C";
    return "D";
  }

  if (max === 25) {
    if (numObtained >= 23) return "A+";
    if (numObtained >= 20) return "A";
    if (numObtained >= 15) return "B+";
    if (numObtained >= 11) return "B";
    if (numObtained >= 9) return "C";
    return "D";
  }

  // default fallback (if unknown maxMarks)
  const percentage = (numObtained / max) * 100;
  if (percentage >= 88) return "A+";
  if (percentage >= 80) return "A";
  if (percentage >= 70) return "B+";
  if (percentage >= 60) return "B";
  if (percentage >= 40) return "C";
  return "D";
};



        return (
          <div className="scholastic-section">
            <h4>Scholastic</h4>
            <table className="results-table">
              <thead>
                <tr>
                  {["Subject", "Max Marks", "Marks Obtained", "Grade"].map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {subjects.map((subject) => {
                  const key = `${currentStudent.student_id}-${subject.id}-obtained`;
                  const obtainedMarks = marks[key] || "";
                  const calculatedGrade = calculateGrade(obtainedMarks, subject.maxMarks);

                  return (
                    <tr key={subject.id}>
                      <td>{subject.name}</td>
                      <td>{subject.maxMarks}</td>
                      <td>
                        <input
                          type="text"
                          value={obtainedMarks}
                          onChange={(e) =>
                            handleMarksChange(currentStudent.student_id, `${subject.id}-obtained`, e.target.value)
                          }
                          disabled={isAdminFinalized}
                          className="marks-input"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={calculatedGrade}
                          readOnly
                          style={{ width: "60px" }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      },
      renderCoScholastic: (coSubjects, coMarks, handleCoMarksChange, currentStudent, isAdminFinalized) => (
        <div className="co-scholastic-section">
          <h4>Co-Scholastic</h4>
          <table className="results-table">
            <thead>
              <tr>
                {["Subjects", "Grade"].map((header) => (
                  <th key={header}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {coSubjects.map((coSubject) => {
                const key = `${currentStudent.student_id}-${coSubject.id}-obtained`;
                return (
                  <tr key={coSubject.id}>
                    <td>{coSubject.name}</td>
                    <td>
                      {isAdminFinalized ? (
                        <span>{coMarks[key] || "N/A"}</span>
                      ) : (
                        <select
                          value={coMarks[key] || ""}
                          onChange={(e) => handleCoMarksChange(currentStudent.student_id, `${coSubject.id}-obtained`, e.target.value)}
                          disabled={isAdminFinalized}
                        >
                          <option value="">Select Grade</option>
                          {["AB", "B+", "A", "A+"].map((grade) => (
                            <option key={grade} value={grade}>{grade}</option>
                          ))}
                        </select>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
      renderTraits: (traitObservations, traitRemarks, handleTraitRemarksChange, currentStudent, isAdminFinalized) => (
        <div className="trait-observation-section">
          <h4>Observation</h4>
          <table className="results-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              {traitObservations.map((trait) => {
                const key = `${currentStudent.student_id}-${trait.id}`;
                return (
                  <tr key={trait.id}>
                    <td>{trait.name}</td>
                    <td>
                      <select
                        value={traitRemarks[key] || ""}
                        onChange={(e) => handleTraitRemarksChange(currentStudent.student_id, trait.id, e.target.value)}
                        disabled={isAdminFinalized}
                        className="grade-select"
                      >
                        <option value="">Select Grade</option>
                        {["A+", "A", "B+", "B", "C", "AB"].map((grade) => (
                          <option key={grade} value={grade}>{grade}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
    },
  },

  "8": {
    scholastic: [
    { id: "eng_paper1", name: "English Paper I (Language)", spec: "English Paper I (Language)", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "eng_paper2", name: "English Paper II (Literature)", spec: "English Paper II (Literature)", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "ii_language", name: "II Language", spec: "II Language", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "iii_language", name: "III Language", spec: "III Language", maxMarks: { unitTest: 25, termExam: 50 } },
    { id: "hcg_paper1", name: "H.C.G Paper I (History & Civics)", spec: "H.C.G Paper I (History & Civics)", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "hcg_paper2", name: "H.C.G Paper II (Geography)", spec: "H.C.G Paper II (Geography)", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "math", name: "Mathematics", spec: "Mathematics", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "physics", name: "Physics", spec: "Physics", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "chemistry", name: "Chemistry", spec: "Chemistry", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "biology", name: "Biology", spec: "Biology", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "computer_app", name: "Computer Application", spec: "Computer Application", maxMarks: { unitTest: 50, termExam: 100 } }
  ],
    coScholastic: [
      { id: "co_analytical_thinking", name: "Analytical Thinking" },
      { id: "co_value_education", name: "Value Education" },
      { id: "co_robotics", name: "Robotics" },
      { id: "co_communication_skill", name: "Communication Skill" },
      { id: "co_vocational_edu", name: "Vocational Education / SUPW / Art & Craft" },
    ],
    traitObservations: [
      { id: "trait_punctuality", name: "Punctuality" },
      { id: "trait_enthusiasm", name: "Enthusiasm & Confidence" },
      { id: "trait_class_participation", name: "Participation – Classroom" },
      { id: "trait_outdoor", name: "Participation – Outdoor" },
      { id: "trait_eca", name: "ECA" },
      { id: "trait_cca", name: "CCA" },
      { id: "trait_neatness", name: "Neatness" },
      { id: "trait_discipline", name: "Discipline" },
    ],
    template: {
      scholasticFields: ["Subject", "Max Marks", "Marks Obtained", "Grade"],
      renderScholastic: (subjects, marks, handleMarksChange, currentStudent, isAdminFinalized) => {
                 const calculateGrade = (obtained, max) => {
  if (obtained === "") return ""; // Don't assign a grade if marks are not entered

  const numObtained = parseFloat(obtained);
  if (isNaN(numObtained) || numObtained > max) return "";

  if (max === 100) {
    if (numObtained >= 94) return "A+";
    if (numObtained >= 84) return "A";
    if (numObtained >= 69) return "B+";
    if (numObtained >= 49) return "B";
    if (numObtained >= 39) return "C";
    return "D";
  }

  if (max === 50) {
    if (numObtained >= 44) return "A+";
    if (numObtained >= 39) return "A";
    if (numObtained >= 34) return "B+";
    if (numObtained >= 29) return "B";
    if (numObtained >= 19) return "C";
    return "D";
  }

  if (max === 25) {
    if (numObtained >= 23) return "A+";
    if (numObtained >= 20) return "A";
    if (numObtained >= 15) return "B+";
    if (numObtained >= 11) return "B";
    if (numObtained >= 9) return "C";
    return "D";
  }

  // default fallback (if unknown maxMarks)
  const percentage = (numObtained / max) * 100;
  if (percentage >= 88) return "A+";
  if (percentage >= 80) return "A";
  if (percentage >= 70) return "B+";
  if (percentage >= 60) return "B";
  if (percentage >= 40) return "C";
  return "D";
};


        return (
          <div className="scholastic-section">
            <h4>Scholastic</h4>
            <table className="results-table">
              <thead>
                <tr>
                  {["Subject", "Max Marks", "Marks Obtained", "Grade"].map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {subjects.map((subject) => {
                  const key = `${currentStudent.student_id}-${subject.id}-obtained`;
                  const obtainedMarks = marks[key] || "";
                  const calculatedGrade = calculateGrade(obtainedMarks, subject.maxMarks);

                  return (
                    <tr key={subject.id}>
                      <td>{subject.name}</td>
                      <td>{subject.maxMarks}</td>
                      <td>
                        <input
                          type="text"
                          value={obtainedMarks}
                          onChange={(e) =>
                            handleMarksChange(currentStudent.student_id, `${subject.id}-obtained`, e.target.value)
                          }
                          disabled={isAdminFinalized}
                          className="marks-input"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={calculatedGrade}
                          readOnly
                          style={{ width: "60px" }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      },
      renderCoScholastic: (coSubjects, coMarks, handleCoMarksChange, currentStudent, isAdminFinalized) => (
        <div className="co-scholastic-section">
          <h4>Co-Scholastic</h4>
          <table className="results-table">
            <thead>
              <tr>
                {["Subjects", "Grade"].map((header) => (
                  <th key={header}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {coSubjects.map((coSubject) => {
                const key = `${currentStudent.student_id}-${coSubject.id}-obtained`;
                return (
                  <tr key={coSubject.id}>
                    <td>{coSubject.name}</td>
                    <td>
                      {isAdminFinalized ? (
                        <span>{coMarks[key] || "N/A"}</span>
                      ) : (
                        <select
                          value={coMarks[key] || ""}
                          onChange={(e) => handleCoMarksChange(currentStudent.student_id, `${coSubject.id}-obtained`, e.target.value)}
                          disabled={isAdminFinalized}
                        >
                          <option value="">Select Grade</option>
                          {["AB", "B+", "A", "A+"].map((grade) => (
                            <option key={grade} value={grade}>{grade}</option>
                          ))}
                        </select>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
      renderTraits: (traitObservations, traitRemarks, handleTraitRemarksChange, currentStudent, isAdminFinalized) => (
        <div className="trait-observation-section">
          <h4>Observation</h4>
          <table className="results-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              {traitObservations.map((trait) => {
                const key = `${currentStudent.student_id}-${trait.id}`;
                return (
                  <tr key={trait.id}>
                    <td>{trait.name}</td>
                    <td>
                      <select
                        value={traitRemarks[key] || ""}
                        onChange={(e) => handleTraitRemarksChange(currentStudent.student_id, trait.id, e.target.value)}
                        disabled={isAdminFinalized}
                        className="grade-select"
                      >
                        <option value="">Select Grade</option>
                        {["A+", "A", "B+", "B", "C", "AB"].map((grade) => (
                          <option key={grade} value={grade}>{grade}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
    },
  },

"9": {
   scholastic: {
  common: [
    { id: "eng_paper1", name: "English Paper I (Language)", spec: "English Paper I (Language)", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "eng_paper2", name: "English Paper II (Literature)", spec: "English Paper II (Literature)", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "ii_language", name: "II Language", spec: "II Language", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "hcg_paper1", name: "H.C.G Paper I (History & Civics)", spec: "H.C.G Paper I (History & Civics)", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "hcg_paper2", name: "H.C.G Paper II (Geography)", spec: "H.C.G Paper II (Geography)", maxMarks: { unitTest: 50, termExam: 100 } }
  ],
  science: [
    { id: "math", name: "Mathematics", spec: "Mathematics", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "physics", name: "Physics", spec: "Physics", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "chemistry", name: "Chemistry", spec: "Chemistry", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "biology", name: "Biology", spec: "Biology", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "computer_app", name: "Computer Application / Robotics & AI", spec: "Computer Application / Robotics & AI", maxMarks: { unitTest: 50, termExam: 100 } }
  ],
  commerce: [
    { id: "math", name: "Mathematics / Economics", spec: "Mathematics / Economics", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "commercial_studies", name: "Commercial Studies", spec: "Commercial Studies", maxMarks: { unitTest: 50, termExam: 100 } },
    { id: "computer_app", name: "Computer Application / Robotics & AI", spec: "Computer Application / Robotics & AI", maxMarks: { unitTest: 50, termExam: 100 } }
  ]
  },
    coScholastic: [],
    traitObservations: [
      { id: "trait_punctuality", name: "Punctuality" },
      { id: "trait_enthusiasm", name: "Enthusiasm & Confidence" },
      { id: "trait_class_participation", name: "Participation – Classroom" },
      { id: "trait_outdoor", name: "Participation – Outdoor" },
      { id: "trait_eca", name: "ECA" },
      { id: "trait_cca", name: "CCA" },
      { id: "trait_neatness", name: "Neatness" },
      { id: "trait_discipline", name: "Discipline" },
      { id: "trait_supw", name: "SUPW" },
    ],
    template: {
      scholasticFields: ["Subject", "Max Marks", "Marks Obtained", "Grade"],
      renderScholastic: (subjects, marks, handleMarksChange, currentStudent, isAdminFinalized) => {
         const calculateGrade = (obtained, max) => {
  if (obtained === "") return ""; // Don't assign a grade if marks are not entered

  const numObtained = parseFloat(obtained);
  if (isNaN(numObtained) || numObtained > max) return "";

  if (max === 100) {
    if (numObtained >= 94) return "A+";
    if (numObtained >= 84) return "A";
    if (numObtained >= 69) return "B+";
    if (numObtained >= 49) return "B";
    if (numObtained >= 39) return "C";
    return "D";
  }

  if (max === 50) {
    if (numObtained >= 44) return "A+";
    if (numObtained >= 39) return "A";
    if (numObtained >= 34) return "B+";
    if (numObtained >= 29) return "B";
    if (numObtained >= 19) return "C";
    return "D";
  }

  if (max === 25) {
    if (numObtained >= 23) return "A+";
    if (numObtained >= 20) return "A";
    if (numObtained >= 15) return "B+";
    if (numObtained >= 11) return "B";
    if (numObtained >= 9) return "C";
    return "D";
  }

  // default fallback (if unknown maxMarks)
  const percentage = (numObtained / max) * 100;
  if (percentage >= 88) return "A+";
  if (percentage >= 80) return "A";
  if (percentage >= 70) return "B+";
  if (percentage >= 60) return "B";
  if (percentage >= 40) return "C";
  return "D";
};

        return (
          <div className="scholastic-section">
            <h4>Scholastic</h4>
            <table className="results-table">
              <thead>
                <tr>
                  {["Subject", "Max Marks", "Marks Obtained", "Grade"].map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {subjects.map((subject) => {
                  const key = `${currentStudent.student_id}-${subject.id}-obtained`;
                  const obtainedMarks = marks[key] || "";
                  const calculatedGrade = calculateGrade(obtainedMarks, subject.maxMarks);

                  return (
                    <tr key={subject.id}>
                      <td>{subject.name}</td>
                      <td>{subject.maxMarks}</td>
                      <td>
                        <input
                          type="text"
                          value={obtainedMarks}
                          onChange={(e) =>
                            handleMarksChange(currentStudent.student_id, `${subject.id}-obtained`, e.target.value)
                          }
                          disabled={isAdminFinalized}
                          className="marks-input"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={calculatedGrade}
                          readOnly
                          style={{ width: "60px" }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      },
     renderCoScholastic: () => null,
      renderTraits: (traitObservations, traitRemarks, handleTraitRemarksChange, currentStudent, isAdminFinalized) => (
        <div className="trait-observation-section">
          <h4>Observation</h4>
          <table className="results-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              {traitObservations.map((trait) => {
                const key = `${currentStudent.student_id}-${trait.id}`;
                return (
                  <tr key={trait.id}>
                    <td>{trait.name}</td>
                    <td>
                      <select
                        value={traitRemarks[key] || ""}
                        onChange={(e) => handleTraitRemarksChange(currentStudent.student_id, trait.id, e.target.value)}
                        disabled={isAdminFinalized}
                        className="grade-select"
                      >
                        <option value="">Select Grade</option>
                        {["A+", "A", "B+", "B", "C", "AB"].map((grade) => (
                          <option key={grade} value={grade}>{grade}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
    },
  },

"10": {
    scholastic: {
    common: [
      { id: "eng_paper1", name: "English Paper I (Language)", spec: "English Paper I (Language)", maxMarks: { unitTest: 50, termExam: 100 } },
      { id: "eng_paper2", name: "English Paper II (Literature)", spec: "English Paper II (Literature)", maxMarks: { unitTest: 50, termExam: 100 } },
      { id: "ii_language", name: "II Language", spec: "II Language", maxMarks: { unitTest: 50, termExam: 100 } },
      { id: "hcg_paper1", name: "H.C.G Paper I (History & Civics)", spec: "H.C.G Paper I (History & Civics)", maxMarks: { unitTest: 50, termExam: 100 } },
      { id: "hcg_paper2", name: "H.C.G Paper II (Geography)", spec: "H.C.G Paper II (Geography)", maxMarks: { unitTest: 50, termExam: 100 } }
    ],
    science: [
      { id: "math", name: "Mathematics", spec: "Mathematics", maxMarks: { unitTest: 50, termExam: 100 } },
      { id: "physics", name: "Physics", spec: "Physics", maxMarks: { unitTest: 50, termExam: 100 } },
      { id: "chemistry", name: "Chemistry", spec: "Chemistry", maxMarks: { unitTest: 50, termExam: 100 } },
      { id: "biology", name: "Biology", spec: "Biology", maxMarks: { unitTest: 50, termExam: 100 } },
      { id: "computer_app", name: "Computer Application / Robotics & AI", spec: "Computer Application / Robotics & AI", maxMarks: { unitTest: 50, termExam: 100 } }
    ],
    commerce: [
      { id: "math", name: "Mathematics / Economics", spec: "Mathematics / Economics", maxMarks: { unitTest: 50, termExam: 100 } },
      { id: "commercial_studies", name: "Commercial Studies", spec: "Commercial Studies", maxMarks: { unitTest: 50, termExam: 100 } },
      { id: "computer_app", name: "Computer Application / Robotics & AI", spec: "Computer Application / Robotics & AI", maxMarks: { unitTest: 50, termExam: 100 } }
    ]
  },
    coScholastic: [],
    traitObservations: [
      { id: "trait_punctuality", name: "Punctuality" },
      { id: "trait_enthusiasm", name: "Enthusiasm & Confidence" },
      { id: "trait_class_participation", name: "Participation – Classroom" },
      { id: "trait_outdoor", name: "Participation – Outdoor" },
      { id: "trait_eca", name: "ECA" },
      { id: "trait_cca", name: "CCA" },
      { id: "trait_neatness", name: "Neatness" },
      { id: "trait_discipline", name: "Discipline" },
      { id: "trait_supw", name: "SUPW" },
    ],
    template: {
      scholasticFields: ["Subject", "Max Marks", "Marks Obtained", "Grade"],
      renderScholastic: (subjects, marks, handleMarksChange, currentStudent, isAdminFinalized) => {
         const calculateGrade = (obtained, max) => {
  if (obtained === "") return ""; // Don't assign a grade if marks are not entered

  const numObtained = parseFloat(obtained);
  if (isNaN(numObtained) || numObtained > max) return "";

  if (max === 100) {
    if (numObtained >= 94) return "A+";
    if (numObtained >= 84) return "A";
    if (numObtained >= 69) return "B+";
    if (numObtained >= 49) return "B";
    if (numObtained >= 39) return "C";
    return "D";
  }

  if (max === 50) {
    if (numObtained >= 44) return "A+";
    if (numObtained >= 39) return "A";
    if (numObtained >= 34) return "B+";
    if (numObtained >= 29) return "B";
    if (numObtained >= 19) return "C";
    return "D";
  }

  if (max === 25) {
    if (numObtained >= 23) return "A+";
    if (numObtained >= 20) return "A";
    if (numObtained >= 15) return "B+";
    if (numObtained >= 11) return "B";
    if (numObtained >= 9) return "C";
    return "D";
  }

  // default fallback (if unknown maxMarks)
  const percentage = (numObtained / max) * 100;
  if (percentage >= 88) return "A+";
  if (percentage >= 80) return "A";
  if (percentage >= 70) return "B+";
  if (percentage >= 60) return "B";
  if (percentage >= 40) return "C";
  return "D";
};

        return (
          <div className="scholastic-section">
            <h4>Scholastic</h4>
            <table className="results-table">
              <thead>
                <tr>
                  {["Subject", "Max Marks", "Marks Obtained", "Grade"].map((header) => (
                    <th key={header}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {subjects.map((subject) => {
                  const key = `${currentStudent.student_id}-${subject.id}-obtained`;
                  const obtainedMarks = marks[key] || "";
                  const calculatedGrade = calculateGrade(obtainedMarks, subject.maxMarks);

                  return (
                    <tr key={subject.id}>
                      <td>{subject.name}</td>
                      <td>{subject.maxMarks}</td>
                      <td>
                        <input
                          type="text"
                          value={obtainedMarks}
                          onChange={(e) =>
                            handleMarksChange(currentStudent.student_id, `${subject.id}-obtained`, e.target.value)
                          }
                          disabled={isAdminFinalized}
                          className="marks-input"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={calculatedGrade}
                          readOnly
                          style={{ width: "60px" }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        );
      },
     renderCoScholastic: () => null,
      renderTraits: (traitObservations, traitRemarks, handleTraitRemarksChange, currentStudent, isAdminFinalized) => (
        <div className="trait-observation-section">
          <h4>Observation</h4>
          <table className="results-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              {traitObservations.map((trait) => {
                const key = `${currentStudent.student_id}-${trait.id}`;
                return (
                  <tr key={trait.id}>
                    <td>{trait.name}</td>
                    <td>
                      <select
                        value={traitRemarks[key] || ""}
                        onChange={(e) => handleTraitRemarksChange(currentStudent.student_id, trait.id, e.target.value)}
                        disabled={isAdminFinalized}
                        className="grade-select"
                      >
                        <option value="">Select Grade</option>
                        {["A+", "A", "B+", "B", "C", "AB"].map((grade) => (
                          <option key={grade} value={grade}>{grade}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ),
    },
  },
};